import { getDealerCooperateInsuraceCompanyListRequest, } from '@/assets/request/QuoteRequest'
export default {
  namespaced: true,
  state: {
    cooperateInsuranceCompanyList: [],
    ins_ids: [], /** 询价机构，多级下拉版本,选中的内容 */
  },
  mutations: {
    _setIns_Ids(state, data) {
      state.ins_ids = toString.call(data) === '[object Array]' ? data : []
    },
    _setInsuranceCompanyList(state, list) {
      state.cooperateInsuranceCompanyList = toString.call(list) === '[object Array]' ? list : []
    },
  },
  actions: {
    setInsuranceCompanyList({ commit }) {
      getDealerCooperateInsuraceCompanyListRequest().then(r => {
        const { data: res, } = r
        if (Number(res.code) === 200) {
          commit('_setInsuranceCompanyList', res.data)
        }
      })
    },
  },
  getters: {
    QuoteGetter: state => state,
    /**
     * 可以编辑运费价格的判断
     */
    canEditFreightComputed: (state, getter, rootState, rootGetter) => {
      if (!rootGetter.dealerGetQuoteInfoGetter) return false;
      const quote_price_type = (() => {
        const item = rootGetter.dealerGetQuoteInfoGetter.quoteDetailData.insInfo
        if (!item) return null
        return Number(item.quote_price_type)
      })()
      /* 
      2：该保险公司要求把运费含在配件价格里
      0：该保险公司要求把运费和税票都含在配件价格里
      */
      if (quote_price_type !== null && [0, 2].includes(quote_price_type)) return false
      return rootGetter.dealerGetQuoteInfoGetter.is_freight
    },
    /**
     * 禁止写入运费的提示
     * @returns 
     */
    disableWriteFreightTipsComputed: (state, getter, rootState, rootGetter) => {
      if (!rootGetter.dealerGetQuoteInfoGetter) return '';
      const quote_price_type = (() => {
        const item = rootGetter.dealerGetQuoteInfoGetter.quoteDetailData.insInfo
        if (!item) return null
        return Number(item.quote_price_type)
      })()
      /* 
      2：该保险公司要求把运费含在配件价格里
      0：该保险公司要求把运费和税票都含在配件价格里
      */
      if (quote_price_type === 0) return '该保险公司要求把运费和税票都含在配件价格里'
      if (quote_price_type === 2) return '该保险公司要求把运费含在配件价格里'
      return ''
    },
    quoteRemarkPlaceholder: (state, getter, rootState, rootGetter) => {
      if (!rootGetter.dealerGetQuoteInfoGetter) return '';
      if (!rootGetter.dealerGetQuoteInfoGetter.quoteDetailData.insInfo) return '请输入报价备注'
      return Number(rootGetter.dealerGetQuoteInfoGetter.quoteDetailData.insInfo.quote_remark_type) === 1 ? '该询价单不支持输入备注' : '请输入报价备注'
    },
    quoteRemarkDisabled: (state, getter, rootState, rootGetter) => {
      if (!rootGetter.dealerGetQuoteInfoGetter) return '';
      if (!rootGetter.dealerGetQuoteInfoGetter.quoteDetailData.insInfo) return false
      return Number(rootGetter.dealerGetQuoteInfoGetter.quoteDetailData.insInfo.quote_remark_type) === 1
    },
    backReason: (state, getter, rootState, rootGetter) => {
      if (!rootGetter.dealerGetQuoteInfoGetter) return '';
      return rootGetter.dealerGetQuoteInfoGetter.quoteDetailData.return
    },
  },
}